module.exports = __webpack_public_path__ + "static/media/Audrey.e73ad952.jpeg";